import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import { coursesAPI } from '../services/api';
import { createCheckoutSession } from '../services/paymentApi';

const Packages = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    loadPackages();
  }, []);

  const loadPackages = async () => {
    try {
      const response = await coursesAPI.getPackages();
      setPackages(response.data);
    } catch (error) {
      console.error('Error loading packages:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleBuyPackage = async (packageId) => {
    try {
      await createCheckoutSession(packageId);
    } catch (error) {
      console.error('Payment error:', error);
      alert('Fehler beim Starten des Zahlungsvorgangs!');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-secondary-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-secondary-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <h1 className="text-2xl font-bold bg-gradient-to-r from-primary-600 to-secondary-600 bg-clip-text text-transparent">
              🎸 Guitar Academy
            </h1>
            <div className="flex items-center space-x-4">
              {user && (
                <>
                  <button
                    onClick={() => navigate('/dashboard')}
                    className="px-4 py-2 text-gray-700 hover:text-primary-600 font-medium"
                  >
                    Dashboard
                  </button>
                  <button
                    onClick={() => {
                      logout();
                      navigate('/');
                    }}
                    className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 font-medium"
                  >
                    Logout
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* Main */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Wähle dein Paket
          </h2>
          <p className="text-gray-600 text-lg">
            Starte jetzt deine Gitarren-Reise und lerne von den Besten!
          </p>
        </div>

        {packages.length === 0 ? (
          <div className="bg-white rounded-2xl shadow-xl p-12 text-center">
            <p className="text-gray-500 text-lg">Aktuell sind keine Pakete verfügbar.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {packages.map((pkg) => (
              <div
                key={pkg.id}
                className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 hover:shadow-2xl transition-all transform hover:scale-105"
              >
                <div className="h-3 bg-gradient-to-r from-primary-500 to-secondary-500"></div>
                
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    {pkg.name}
                  </h3>
                  
                  <div className="mb-6">
                    <span className="text-4xl font-bold text-gray-900">
                      {pkg.price}€
                    </span>
                    <span className="text-gray-600 ml-2">
                      / {pkg.duration_days} Tage
                    </span>
                  </div>

                  <p className="text-gray-600 mb-6 min-h-[60px]">
                    {pkg.description}
                  </p>

                  <button
                    onClick={() => handleBuyPackage(pkg.id)}
                    className="w-full py-3 bg-gradient-to-r from-primary-600 to-secondary-600 text-white font-bold rounded-lg hover:shadow-lg transform hover:scale-105 transition-all"
                  >
                    Jetzt kaufen
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default Packages;
